import type { VenueOSClient } from '@mappedin/venueos-applet';

export interface DirectoryKiosk {
  id?: string;
  name?: string;
  kioskName?: string;
  location?: {
    id?: string;
    name?: string;
    nodeId?: string;
    coordinate?: { latitude: number; longitude: number };
  };
  [key: string]: unknown;
}

/**
 * Fetch directory kiosks for a venue slug / mapId. Replaces the App
 * Builder's `VenueOS.tools.call('get_kiosks', ...)` with the same
 * `/api/mappedin/kiosks/:mapId` route that apps/directory-applet uses.
 */
export async function fetchDirectoryKiosks(
  client: VenueOSClient,
  orgId: string,
  mapId: string,
): Promise<DirectoryKiosk[]> {
  const params = new URLSearchParams({ venueosOrgId: orgId });
  const response = await client.api.fetch(`/api/mappedin/kiosks/${mapId}?${params.toString()}`);

  if (!response.ok || !response.data) return [];

  const body = response.data as { data?: unknown };
  if (!Array.isArray(body.data)) return [];

  const kiosks: DirectoryKiosk[] = [];
  for (const raw of body.data) {
    if (raw && typeof raw === 'object') {
      kiosks.push(raw as DirectoryKiosk);
    }
  }
  return kiosks;
}
